export default __webpack_public_path__ + "static/media/icon-bilateralCarry.efa037a9.svg";